<section class="{{ classes }} main-section position-relative"
         [ngClass]="{'show-border': showBorder === true, 'mobile-mode': mobileMode}" (click)="cardClicked($event)">
  <div class="content-section-border left h-100"></div>
  <div class="content-section-border right h-100"></div>
  <div class="content-section-border bottom w-100"></div>
  <div class="all-content-section">

    <!-- non-carousel -->
    <div *ngIf="!!imageUrl && showTopImage && (!mediaItems || mediaItems.length === 0)"
         class="aspect-ratio-box-3-2 image-content p-0" [ngClass]="{'d-none d-md-block': mobileMode}">
      <div class="image-content-inner position-absolute w-100 h-100"
           defaultImage="/assets/images/blur.jpg" [lazyLoad]="imageUrl" offset="100">
        &nbsp;
        <span *ngIf="topImageLink && topImageLinkText" class="top-link-wrapper">
          <span class="cursor-pointer {{ topImageLinkClasses }}" [routerLink]="topImageLink" [innerHTML]="safeHtml('topImageLinkText', topImageLinkText)"></span>
        </span>
      </div>
      <div class="content-section-border top w-100"></div>
    </div>

    <!-- carousel -->
    <div *ngIf="!!mediaItems && mediaItems.length > 0" class="aspect-ratio-box-3-2">
      <span *ngIf="topImageLink && topImageLinkText" class="top-link-wrapper">
        <span class="cursor-pointer {{ topImageLinkClasses }}" [routerLink]="topImageLink" [innerHTML]="safeHtml('topImageLinkText', topImageLinkText)"></span>
      </span>

      <carousel #cardCarousel [interval]="0">
        <slide [active]="true">
          <div *ngIf="!!imageUrl" class="aspect-ratio-box-3-2 background content-padding"
               [style.background-image]="safeStyle(imageUrl)">
          </div>
        </slide>

        <slide *ngFor="let media of mediaItems">
          <span *ngIf="topImageLink && topImageLinkText" class="top-link-wrapper" [ngClass]="{'top-link-wrapper-bg': !!media.embedUrl }">
            <span class="cursor-pointer {{ topImageLinkClasses }}" [routerLink]="topImageLink" [innerHTML]="safeHtml('topImageLinkText', topImageLinkText)"></span>
          </span>

          <div *ngIf="!!media.imageUrl" class="background content-padding aspect-ratio-box-3-2"
               [style.background-image]="safeStyle(media.imageUrl)">
          </div>

          <div *ngIf="!!media.embedUrl && !!safeResourceUrlCache[media.embedUrl]" class="aspect-ratio-box-16-9">
            <div class="iframe-container">
              {{ media.embedUrl }}, {{ safeResourceUrlCache[media.embedUrl] }}
              <iframe id="player"
                      [src]="safeResourceUrlCache[media.embedUrl][autoplayVideo]"
                      allowfullscreen=""
                      allow="autoplay; encrypted-media"
                      data-aspectratio="0.5625"
                      class="h-100 w-100"
                      frameborder="0"></iframe>
            </div>
          </div>
        </slide>
      </carousel>
    </div>

    <div class="content-section-wrapper">
      <div class="content-section {{ paddingClasses }} no-gutter"
           [ngClass]="{'aspect-ratio-box-3-2-mobile': mobileMode}"
           [defaultImage]="mobileMode ? '/assets/images/blur.jpg' : null"
           [lazyLoad]="mobileMode ? imageUrl : null">

        <!-- HEADER START -->
        <div *ngIf="!!topLeft || !!topRight" class="d-flex justify-content-between header-row">
          <div class="top-left {{ topLeftClasses }}"
               [routerLink]="topLeftLink"
               [style.pointer-events]="!topLeftLink ? 'none' : 'auto'"
               [style.cursor]="!topLeftLink ? 'none' : 'pointer'">

            <!-- center this text in this div, which may have a background -->
            <span class="top-left-text h6"><span class='{{ topLeftTextClasses }}' [innerHTML]="safeHtml('topLeft', topLeft)"></span></span>
          </div>

          <div class="top-right text-right {{ topRightClasses }}" [ngClass]="{'d-none d-lg-block': mobileMode}">
            <span class="top-right-text"><span class="{{ topRightTextClasses }}" [innerHTML]="safeHtml('topRight', topRight)"></span></span>
          </div>
        </div>
        <!-- HEADER END -->

        <!-- TITLE START -->
        <div class="title">
          <div *ngIf="!!title" class="title-row">
            <div class="{{ titleClasses }}" [innerHTML]="safeHtml('title', title)"></div>
          </div>

          <div *ngIf="!!subTitle" class="title-row neutral7" [ngClass]="{'d-none d-md-block': mobileMode}">
            <span class="{{ subtitleClasses }} lead" [innerHTML]="safeHtml('subTitle', subTitle)"></span>
          </div>
        </div>
        <!-- TITLE END -->

        <!-- CONTENT START -->
        <div class="content {{ limitDescription ? 'limit-description': '' }}">
          <!-- Link above content -->
          <div *ngIf="!!linkText && !!linkRoute && (linkAboveDescription === true) && !isRemoteUrl(linkRoute)" class="link body-link d-inline-block" (click)="gotoRoute(linkRoute, $event)">
            <span class="{{ linkClasses }}" [innerHTML]="safeHtml('linkText', linkText)"></span>
          </div>
          <div *ngIf="!!linkText && !!linkRoute && (linkAboveDescription === true) && !!isRemoteUrl(linkRoute)" class="link body-link d-inline-block" (click)="goto(linkRoute, $event)">
            <span class="{{ linkClasses }}" [innerHTML]="safeHtml('linkText', linkText)"></span>
          </div>

          <div *ngIf="!!description" class="desc-row {{ descriptionRowClasses }}" [ngClass]="{'d-none d-md-block': mobileMode}">
            <span class="{{ descriptionClasses }} desc" [innerHTML]="safeHtml('description', description)"></span>
          </div>

          <!-- for any ad-hoc content to be transcluded -->
          <ng-content></ng-content>

          <!-- spacer to force long description to push bottom row down -->
          <div *ngIf="!!bottomLeft || !!linkText || !!bottomRight" style="height: 40px; max-height: 40px;"></div>
        </div>
        <!-- CONTENT END -->

        <!-- FOOTER START -->
        <div *ngIf="!!bottomLeft || !!linkText || !!bottomRight" class="footer-row">
          <!-- one of the following -->
          <div *ngIf="!!bottomLeft || !!linkText" class="bottom-left {{ bottomLeftClasses }}">
            <button *ngIf="!!buttonText && !!buttonRoute && !isRemoteUrl(buttonRoute)" (click)="gotoRoute(buttonRoute, $event)" class="btn {{ buttonClasses }}" [ngClass]="{'d-md-inline-block': mobileMode}" [innerHTML]="safeHtml('buttonText', buttonText)"></button>
            <button *ngIf="!!buttonText && !!buttonRoute && !!isRemoteUrl(buttonRoute)" (click)="goto(buttonRoute, $event)" class="btn {{ buttonClasses }}" [ngClass]="{'d-md-inline-block': mobileMode}" [innerHTML]="safeHtml('buttonText', buttonText)"></button>
            <div *ngIf="!!linkText && !!linkRoute && (linkAboveDescription !== true) && !isRemoteUrl(linkRoute)" class="link body-link d-inline-block" (click)="gotoRoute(linkRoute, $event)">
              <span class="{{ linkClasses }}" [innerHTML]="safeHtml('linkText', linkText)"></span>
            </div>
            <div *ngIf="!!linkText && !!linkRoute && (linkAboveDescription !== true) && !!isRemoteUrl(linkRoute)" class="link body-link d-inline-block" (click)="goto(linkRoute, $event)">
              <span class="{{ linkClasses }}" [innerHTML]="safeHtml('linkText', linkText)"></span>
            </div>
          </div>

          <!-- then bottom right -->
          <div *ngIf="!!bottomRight" class="bottom-right {{ bottomRightClasses }}">
            <div class="bottom-right-content {{ bottomRightTextClasses }}" [innerHTML]="safeHtml('bottomRight', bottomRight)"></div>
          </div>
        </div>
        <!-- FOOTER END -->

      </div>
    </div>
  </div>

</section>
